import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for the dashboard, specifying the path and icon using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  NOTIFICATION_MANAGEMENT: {
    path: `${baseRoutes.adminBaseRoutes}/notification`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-bell" />
      </span>
    ),
  },
};

export default accessRoute;
